import Swiper, { Navigation } from 'swiper';

export default () => {
	const thumbnails = document.querySelectorAll('.mobile-product-slider__thumbs button');
	const featuredImages = document.querySelectorAll('.mobile-product-slider ul li');

	if (thumbnails && featuredImages) {
		thumbnails.forEach(element => {
			element.addEventListener('click', function (event) {
				let imageId = element.dataset.image;
				thumbnails.forEach(thumbs => {
					thumbs.classList.remove('active');
				});
				element.classList.add('active');
				featuredImages.forEach(fImage => {
					if (fImage.dataset.image === imageId) {
						fImage.classList.add('active');
					} else {
						fImage.classList.remove('active');
					}
				});
			});
		});
	}


	window.addEventListener("DOMContentLoaded", function (event) {
		const swiper = new Swiper(".mobile-product-slider__thumbs", {
			modules: [Navigation],
			loop: false,
			allowTouchMove: false,
			preventClicks: false,
			preventClicksPropagation: false,
			slidesPerView: 3,
			rewind: true,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev'
			},
			enabled: true,
			spaceBetween: 8,
			direction: 'vertical',
			breakpoints: {
				1024: {
					enabled: false
				}
			}
		});

		if( swiper.$el ) {
			if( swiper.isBeginning && swiper.isEnd ) {
				swiper.$el[0].classList.add('hide-slider-nav')
			} else {
				swiper.$el[0].classList.remove('hide-slider-nav')
			}

			window.addEventListener('resize', function() {
				if( swiper.isBeginning && swiper.isEnd ) {
					swiper.$el[0].classList.add('hide-slider-nav')
				} else {
					swiper.$el[0].classList.remove('hide-slider-nav')
				}
			})
		}
	})
}